import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import LeaveShowGrid from "../ogComponent/leaveShowGrid";
import axios from "axios";
import Spinner from "../ogComponent/spinner";
import { useNavigate } from "react-router-dom";
import { Pagination } from "@mui/material";
import dayjs from "dayjs";
import "./leavesModern.css";

export default function TodayLeaves() {
  const [leaves, setLeaves] = useState([]);
  const [employeeCount, setEmployeeCount] = useState('00');
  const [attendanceCount, setAttendanceCount] = useState("00");
  const [loading, setLoading] = useState(true);
  const [currentPage, setCurrentPage] = useState(1);
  const rowsPerPage = 10;
  const navigate = useNavigate();

  const permissions = useSelector((state) => state.emp.permissions);

  // Pagination logic
  const indexOfLastRow = currentPage * rowsPerPage;
  const indexOfFirstRow = indexOfLastRow - rowsPerPage;
  const currentRows = leaves.slice(indexOfFirstRow, indexOfLastRow);
  const totalPages = Math.ceil(leaves.length / rowsPerPage);

  const handlePageChange = (event, newPage) => {
    setCurrentPage(newPage);
  };

  useEffect(() => {
    const fetchData = async () => {
      const token = localStorage.getItem("accessToken");
      const today = dayjs().format("YYYY-MM-DD");

      try {
        const attRes = await axios.get(
          `${process.env.REACT_APP_API}/api/attendance/attendance/?start_date=${today}&end_date=${today}`,
          { headers: { Authorization: `Bearer ${token}` } }
        );
        setAttendanceCount(attRes.data?.length);

        const empRes = await axios.get(
          `${process.env.REACT_APP_API}/api/account/users-list/?status=true`,
          { headers: { Authorization: `Bearer ${token}` } }
        );
        setEmployeeCount(empRes.data.length - 1);

        const leaveRes = await axios.get(
          `${process.env.REACT_APP_API}/api/leavemanagement/leaves/filter_by_date/`,
          {
            headers: { Authorization: `Bearer ${token}` },
            params: { start_date: today, end_date: today },
          }
        );
        setLeaves(leaveRes.data);
      } catch (error) {
        console.error("Error fetching today leaves data:", error);
      } finally {
        setLoading(false);
      }
    };

    if (permissions.includes("showtodayleavesID")) {
      fetchData();
    } else {
      setLoading(false);
    }
  }, [permissions]);

  const showData = {
    firstHeader: "Total Employees",
    firstCount: employeeCount,
    secondHeader: "Today Attendance",
    secondCount: attendanceCount,
    thirdHeader: "Leaves Today",
    thirdCount: leaves.length,
  };

  const handleRowClick = (leaf) => {
    const userId = localStorage.getItem("userId");
    if (permissions.includes("showtodayleavedetailsID") || String(leaf.employee.id) === String(userId)) {
      navigate(`/user/leavedetails/${leaf.employee.id}/${leaf.id}/`);
    }
  };

  if (loading) return <Spinner />;

  return (
    <div className="todayLeavesContainer w-100 d-flex flex-column p-0 gap-4">
      {/* <LeaveShowGrid showData={showData} /> */}

      <div className="d-flex justify-content-between align-items-center mt-2 px-2">
        <h3 className="m-0">Today's Leaves</h3>
        <span className="badge bg-primary bg-opacity-10 text-primary px-3 py-2 rounded-pill">
          {dayjs().format("DD MMMM YYYY")}
        </span>
      </div>

      {permissions.includes("showtodayleavesID") ? (
        leaves.length === 0 ? (
          <div className="d-flex flex-column justify-content-center align-items-center py-5 today-leaves-card">
            <img src="/assets/file.png" alt="empty" style={{ width: 120, opacity: 0.2 }} />
            <p className="mt-3 fw-medium text-muted">No employees on leave today</p>
          </div>
        ) : (
          <div className="today-leaves-card overflow-hidden">
            <div className="table-responsive">
              <table className="custom-table">
                <thead>
                  <tr>
                    <th>#</th>
                    <th>Employee</th>
                    <th>Branch</th>
                    <th>Leave Type</th>
                    <th className="text-center">Status</th>
                  </tr>
                </thead>
                <tbody>
                  {currentRows.map((leaf, index) => (
                    <tr key={leaf.id} onClick={() => handleRowClick(leaf)}>
                      <td data-label="#">{indexOfFirstRow + index + 1}</td>
                      <td data-label="Employee">
                        <div className="d-flex align-items-center gap-3">
                          <div className="emp-avatar-wrapper">
                            <img
                              src={leaf.employee?.profile_photo || "/assets/user.png"}
                              alt="avatar"
                              className="emp-avatar"
                            />
                          </div>
                          <div>
                            <div className="emp-name-bold">{leaf.employee?.name || "N/A"}</div>
                            <div className="emp-code-small">ID: {leaf.employee?.employee_code || "N/A"}</div>
                          </div>
                        </div>
                      </td>
                      <td data-label="Branch">
                        <span className="text-muted fw-semibold" style={{ fontSize: '13px' }}>
                          {leaf.employee?.branch?.branch_name || "N/A"}
                        </span>
                      </td>
                      <td data-label="Leave Type">
                        <span className="leave-type-badge">
                          {leaf.leave_type || "N/A"}
                        </span>
                      </td>
                      <td data-label="Status" className="text-center">
                        <div className={`status-pill-custom ${leaf.status === 'Approved' ? 'status-pill-approved' : 'status-pill-pending'}`}>
                          <span className="dot"></span>
                          {leaf.status || "Pending"}
                        </div>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>

            {totalPages > 1 && (
              <div className="d-flex justify-content-center mt-4">
                <Pagination
                  count={totalPages}
                  page={currentPage}
                  onChange={handlePageChange}
                  color="primary"
                  size="medium"
                  sx={{
                    "& .MuiPaginationItem-root": {
                      fontWeight: 600,
                      borderRadius: '10px',
                    },
                  }}
                />
              </div>
            )}
          </div>
        )
      ) : (
        <div className="alert alert-warning">No permission to view today's leaves.</div>
      )}
    </div>
  );
}
